import sanitizeHtml from 'sanitize-html'

export const downloadBlob = (fileName: string, file: Blob) => {
  const url = window.URL.createObjectURL(file)

  const link = document.createElement('a')
  link.href = sanitizeHtml(url)
  link.setAttribute('download', fileName)

  const element = document.body || document.documentElement

  element.appendChild(link)
  link.click()
  element.removeChild(link)
}
